import SectionHead from "../components/site/SectionHead";
import EligibilityChecker from "../components/site/EligibilityChecker";

export default function EligibilityPage() {
  return (
    <div data-testid="eligibility-page" className="container-site py-14 lg:py-20">
      <SectionHead eyebrow="Eligibility Checker" title="Check Your Indicative Loan Eligibility"
        subtitle="Answer a few questions to get an instant indicative estimate. This is not an approval — final eligibility and terms are determined by the respective lending partner after verification." />
      <div className="mt-12"><EligibilityChecker /></div>
    </div>
  );
}
